module.exports = __webpack_public_path__ + "media/images/icon-connect-66cb1e5f326e105c43e31496e314a40e.svg";